export default function Dropdown({
  name,
  selectedValue,
  setSelectedValue,
  errorMessage,
  options,
}) {
  return (
    <div className="oe-form-field">
      <label className="oe-form-field__title">{name}</label>
      <select
        className="oe-form-field__control"
        value={selectedValue}
        onChange={(e) => {
          setSelectedValue(e.target.value);
        }}
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {errorMessage && <div className="oe-form-field__error">{errorMessage}</div>}
    </div>
  );
}